<template>
	<div class="data-content">
		<div class="top-box">
			<div>
				<button class="add-btn" @click="handleEditData('add')" v-if="perms.includes('sys:agent:add')">新增</button>
				<button class="import-btn" @click="handleImport('sysAgentImport')" v-if="perms.includes('sys:agent:import')">导入</button>
				<input style="display: none" ref="uploadExcel" type="file" id="uploadExcel" @change="uploadHandle($event)" />
				<button class="import-btn" @click="handleExport" v-if="perms.includes('sys:agent:export')">导出</button>
				<el-dropdown placement="bottom" @command="handleCommand" v-if="perms.includes('sys:agent:import')">
					<el-button type="primary" size="small" class="template-btn">模板下载</el-button>
					<template #dropdown>
						<el-dropdown-menu>
							<el-dropdown-item command="default">经销商导入模板</el-dropdown-item>
							<el-dropdown-item command="bind">经销商归属关系绑定模板</el-dropdown-item>
							<el-dropdown-item command="prepaid">先行赔付更新模板</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
				<button class="template-btn" @click="handleImport('importAgentNet')" v-if="perms.includes('sys:agent:import')">归属关系绑定</button>
				<button class="template-btn" @click="handleImport('importAgentPrepaid')" v-if="perms.includes('sys:agent:import')">先行赔付更新</button>
				<button :class="isPrepaid === '1' ? 'add-btn' : 'template-btn'" @click="handlePrepaid" v-if="perms.includes('sys:agent:import')">
					先行赔付
				</button>
			</div>
			<div class="top-right-box">
				<label class="label">关键字</label>
				<el-input class="search-input" size="small" type="text" v-model="searchKey" placeholder="请输入关键字"></el-input>
				<label class="label">区域</label>
				<el-select class="search-input" size="small" v-model="area" filterable placeholder="请选择" @change="handleArea">
					<el-option value="" label="全部"></el-option>
					<el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<label class="label">省市</label>
				<el-select class="search-input" size="small" v-model="provice" filterable placeholder="请选择">
					<el-option value="" label="全部"></el-option>
					<el-option v-for="item in proviceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<label class="label">有效性</label>
				<el-select class="search-input" size="small" v-model="active" filterable placeholder="请选择">
					<el-option value="" label="全部"></el-option>
					<el-option value="1" label="有效"></el-option>
					<el-option value="0" label="失效"></el-option>
				</el-select>
				<label class="label">签约级别</label>
				<el-select class="search-input" size="small" v-model="contractLevel" filterable clearable placeholder="请选择">
					<el-option v-for="item in contractLevelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<img class="search-btn" src="@/assets/images/sousuo.png" alt="" @click="handleSearch" />
				<el-button icon="el-icon-refresh-right" class="refresh-btn" @click="handleReset"></el-button>
			</div>
		</div>
		<div class="data-list-box">
			<el-table :data="dealerList" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" border style="width: 100%">
				<el-table-column width="50" label="NO.">
					<template slot-scope="scope">
						<span class="no">{{ scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="code" width="90" show-overflow-tooltip label="经销商编码"></el-table-column>
				<el-table-column prop="name" show-overflow-tooltip label="经销商名称"></el-table-column>
				<el-table-column prop="rangeName" width="80" show-overflow-tooltip label="区域"></el-table-column>
				<el-table-column prop="areaName" width="80" show-overflow-tooltip label="省市"></el-table-column>
				<el-table-column prop="contractLevelName" show-overflow-tooltip width="100" label="签约级别">
					<template slot-scope="scope">
						<!-- 区域代理 -->
						<button class="btn-blue" @click="handleRelationLevel(scope.row)" v-if="scope.row.contractLevel == '1410436558597210114'">
							{{ scope.row.contractLevelName }}
						</button>
						<span v-else>{{ scope.row.contractLevelName }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="contractTypeName" show-overflow-tooltip width="150" label="签约类型"></el-table-column>
				<el-table-column prop="parentNames" show-overflow-tooltip label="所属经销商"></el-table-column>
				<el-table-column label="状态" align="center" width="50">
					<template slot-scope="scope">
						<span v-if="scope.row.active == 1">Y</span>
						<span v-if="scope.row.active == 0" style="color: red">N</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="90">
					<template slot-scope="scope">
						<button class="btn-blue" @click="handleEditData('check', scope.row)">查看</button>
						<button class="btn-blue" @click="handleEditData('edit', scope.row)" v-if="perms.includes('sys:agent:update')">修改</button>
						<button class="btn-blue" @click="changeStatus(scope.row)" v-if="perms.includes('sys:agent:active') && scope.row.active == 0">
							激活
						</button>
						<button class="btn-red" @click="changeStatus(scope.row)" v-if="perms.includes('sys:agent:invalid') && scope.row.active == 1">
							失效
						</button>
						<button class="btn-red" @click="handleDeleteData(scope.row)" v-if="perms.includes('sys:agent:delete')">删除</button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-wrapper pa25">
				<Pagination
					:page.sync="pageNo"
					:pageSize.sync="pageSize"
					:total="total"
					@sizeChange="handleSizeChange"
					@currentChange="handleCurrentChange"></Pagination>
			</div>
		</div>
		<edit-data ref="editData" @getDealerList="getDealerList"></edit-data>
		<relation-level ref="relationLevel"></relation-level>
		<el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" class="role-dialog" width="450px">
			<span slot="title" class="dialog-title">
				<span>提示</span>
				<img src="@/assets/images/close.png" alt="" @click="visible = false" />
			</span>
			<ul class="error-list">
				<li v-for="(item, i) in errorList" :key="i">{{ item }}</li>
			</ul>
		</el-dialog>
	</div>
</template>
<script>
import EditData from "./components/edit-data";
import RelationLevel from "@/components/RelationLevel";
import Pagination from "@/components/Pagination";
export default {
	components: {
		EditData,
		RelationLevel,
		Pagination,
	},
	data() {
		return {
			// 权限
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			searchKey: "",
			pageNo: 1,
			pageSize: 20,
			total: 0,
			active: "",
			area: "",
			contractLevel: "",
			areaList: [],
			provice: "",
			proviceList: [],
			dealerList: [],
			dataList: [],
			deviceType: "",
			deviceTypeList: [],
			visible: false,
			errorList: [],
			contractLevelList: [],
			importUrl: "",
			isPrepaid: "",
		};
	},
	created() {
		// 获取区域数据
		this.getAreaList();
		this.pageNo = 1;
		this.searchKey = "";
		this.getDealerList();
		this.getCodesList();
	},
	methods: {
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 获取区域数据
		getAreaList() {
			let self = this;
			self.$request.post(
				"sysDataDetailPageList",
				false,
				{
					pageNo: 1,
					pageSize: 999,
					code: "areaType",
				},
				function (r) {
					if (r.code == "0") {
						self.areaList = r.data.list;
					} else {
						self.$message.error(r.msg);
					}
				},
			);
		},
		// 获取省市数据
		handleArea() {
			this.provice = "";
			if (this.area == "") {
				this.proviceList = [];
				return;
			}

			let self = this;
			self.$request.post(
				"sysAreaPageList",
				false,
				{
					pageNo: 1,
					pageSize: 999,
					dataId: self.area,
				},
				function (r) {
					if (r.code == "0") {
						self.proviceList = r.data.list;
					} else {
						self.$message.error(r.msg);
					}
				},
			);
		},
		// 重置查询条件
		handleReset() {
			this.pageNo = 1;
			this.searchKey = "";
			this.area = "";
			this.active = "";
			this.provice = "";
			this.contractLevel = "";
			this.isPrepaid = "";
			this.getDealerList();
		},
		// 获取经销商数据
		getDealerList() {
			let self = this;
			self.$request.post(
				"getDealerList",
				true,
				{
					pageNo: self.pageNo,
					pageSize: self.pageSize,
					searchKey: self.searchKey,
					rangeId: self.area,
					active: self.active,
					areaId: self.provice,
					contractLevel: self.contractLevel,
					isPrepaid: self.isPrepaid,
				},
				function (r) {
					if (r.code == "0") {
						self.dealerList = r.data.list;
						self.total = r.data.totalCount;
					} else {
						self.$message.error(r.msg);
					}
				},
			);
		},
		// 新增/编辑/查看
		handleEditData(type, data) {
			this.$refs.editData.init(type, data);
		},
		// 更改经销商状态
		changeStatus(dt) {
			let tips = dt.active == 1 ? "是否失效当前经销商?" : "是否激活当前经销商?";
			let statusUrl = dt.active == 1 ? "sysAgentInvalid" : "sysAgentActive";
			this.$confirm(tips, {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let self = this;
					self.$request.post(
						statusUrl,
						true,
						{
							id: dt.id,
						},
						function (r) {
							if (r.code == "0") {
								self.getDealerList();
								self.$message.success("经销商状态已变更");
							} else {
								self.$message.error(r.msg);
							}
						},
					);
				})
				.catch(() => {});
		},
		// 删除
		handleDeleteData(data) {
			this.$confirm("是否删除当前经销商?", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let self = this;
					self.$request.post(
						"sysAgentDelete",
						true,
						{
							id: data.id,
							delFlag: 1,
						},
						function (r) {
							if (r.code == "0") {
								self.getDealerList();
								self.$message.success("删除成功");
							} else {
								self.$message.error(r.msg);
							}
						},
					);
				})
				.catch(() => {});
		},
		handleSearch() {
			this.pageNo = 1;
			this.getDealerList();
		},
		handleSizeChange(val) {
			this.getDealerList();
		},
		handleCurrentChange(val) {
			this.getDealerList();
		},
		// 导入
		handleImport(importUrl) {
			let el = document.getElementById("uploadExcel");
			el.click();
			this.importUrl = importUrl;
		},
		// 上传
		uploadHandle(e) {
			let file = e.target.files[0];
			if (file) {
				if (window.sessionStorage.getItem("userInfo").superAdminFlag == "1" && file.size / 1024 / 1024 / 1024 > 1) {
					this.$message.error("导入文件不能大于1GB");
					return;
				}
				// 2022-07-31 应客户要求改为200M
				if (window.sessionStorage.getItem("userInfo").superAdminFlag != "1" && file.size / 1024 / 1024 > 200) {
					this.$message.error("导入文件不能大于200MB");
					return;
				}
				if (file.name.includes(".xlsx")) {
					let formdata = new FormData();
					formdata.append("file", file);
					let self = this;
					self.$request.initUploadExcel(formdata, self.importUrl, true).then((data) => {
						if (data.code == 0) {
							self.pageNo = 1;
							self.getDealerList();
							if (data.data.length > 0) {
								self.visible = true;
								self.errorList = data.data;
							} else {
								self.$message.success("导入成功");
							}
						}
					});
				} else {
					this.$message.error("文件格式不正确");
				}
			} else {
				this.$message.error("请选择上传的文件");
			}
			this.$refs.uploadExcel.value = "";
		},
		// 导出
		handleExport() {
			let self = this;
			self.$request.post(
				"sysAgentExport",
				true,
				{
					searchKey: self.searchKey,
					rangeId: self.area,
					active: self.active,
					areaId: self.provice,
					contractLevel: self.contractLevel,
					isPrepaid: self.isPrepaid,
				},
				function (res) {
					if (res.code == "0") {
						const linkNode = document.createElement("a");
						linkNode.style.display = "none";
						linkNode.href = res.data;
						document.body.appendChild(linkNode);
						linkNode.click(); //模拟在按钮上的一次鼠标单击
						URL.revokeObjectURL(linkNode.href); // 释放URL 对象
						document.body.removeChild(linkNode);
					} else {
						self.$message.error(res.msg);
					}
				},
			);
		},
		// 模板下载
		handleTemplate(downloadHref, downloadName) {
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = downloadHref;
			linkNode.download = downloadName;
			document.body.appendChild(linkNode);
			linkNode.click(); //模拟在按钮上的一次鼠标单击
			URL.revokeObjectURL(linkNode.href); // 释放URL 对象
			document.body.removeChild(linkNode);
		},
		// 获取签约级别
		getCodesList() {
			let self = this;
			self.$request.post(
				"getListByCodes",
				true,
				{
					codes: "contractLevel",
				},
				function (r) {
					if (r.code == "0") {
						self.contractLevelList = r.data.contractLevel;
					} else {
						self.$message.error(r.msg);
					}
				},
			);
		},
		// 关联网络店
		handleRelationLevel(data) {
			this.$refs.relationLevel.init(data);
		},
		// 模板下载
		handleCommand(value) {
			// 经销商导入模板
			if (value === "default") {
				let downloadHref = "/static/template/AGENT-DATA.xlsx";
				let downloadName = "AGENT-DATA.xlsx";
				this.handleTemplate(downloadHref, downloadName);
			}
			// 经销商归属关系绑定模板
			if (value === "bind") {
				let downloadHref = "/static/template/AGENT-NET-DATA.xlsx";
				let downloadName = "AGENT-NET-DATA.xlsx";
				this.handleTemplate(downloadHref, downloadName);
			}
			// 先行赔付更新模板
			if (value === "prepaid") {
				let downloadHref = "/static/template/PREPAID-DATA.xlsx";
				let downloadName = "PREPAID-DATA.xlsx";
				this.handleTemplate(downloadHref, downloadName);
			}
		},
		// 是否先行赔付
		handlePrepaid() {
			this.isPrepaid = this.isPrepaid === "" ? "1" : "";
			this.getDealerList();
		},
	},
};
</script>
<style lang="scss" scoped>
.data-content {
	.top-box {
		// height: 32px;
		margin-bottom: 20px;
	}
	.add-btn {
		display: inline-block;
		width: 88px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: #117ffc;
		border-radius: 4px;
		color: #fff;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}
	.import-btn {
		display: inline-block;
		width: 88px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}
	.template-btn {
		display: inline-block;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
		padding: 0 14px;
		font-weight: normal;
	}
	.top-right-box {
		// float: right;
		text-align: right;
		margin-top: 15px;
		.label {
			font-size: 15px;
			margin-right: 5px;
		}
		.search-input,
		.search-select {
			width: 138px;
			margin: 0 10px;
		}
		.search-btn {
			width: 32px;
			vertical-align: middle;
			cursor: pointer;
		}
		.refresh-btn {
			width: 32px;
			height: 32px;
			border: none;
			color: #117ffc;
			padding: 0;
			background-color: rgba(17, 127, 252, 0.2);
			font-weight: bold;
			font-size: 22px;
			vertical-align: bottom;
			margin-left: 5px;
		}
	}
	.btn-blue,
	.detail-btn {
		font-size: 12px;
		font-weight: bold;
		color: #1081fd;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background-color: #fff;
		margin-right: 10px;
	}
	.btn-red {
		font-size: 12px;
		font-weight: bold;
		color: #e9515e;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background-color: #fff;
		margin-right: 10px;
	}
}
.f-r {
	float: right;
}
.dialog-title {
	display: block;
	text-align: center;
	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}
	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}
.error-list {
	height: 50vh;
	box-sizing: border-box;
	padding: 20px;
	overflow: auto;
	li {
		list-style: none;
	}
}
</style>
